import { render, staticRenderFns } from "./Samara.vue?vue&type=template&id=4148454e&scoped=true"
import script from "./Samara.vue?vue&type=script&lang=js"
export * from "./Samara.vue?vue&type=script&lang=js"
import style0 from "./Samara.vue?vue&type=style&index=0&id=4148454e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4148454e",
  null
  
)

export default component.exports